import React from 'react';
import { keys } from 'lodash';
import Scrollbars from 'react-custom-scrollbars';
import { BannerTypes } from '@gin-betting/banners';
import { BannerZoneLocation } from '@gin-betting/constants';

import { Tabs } from 'components';
import { SidebarView } from 'app-constants';
import { AsyncBetslipList } from 'modules/betslip/async';
import { AsyncBetsHistoryContainer } from 'modules/bets-history/async';
import { AsyncSidebarMarketList } from 'modules/match/async';
import promo from 'modules/promo';
import BannersCarousel from '../BannersCarousel';
import './sidebar.scss';

const {
    components: { Banners, TopMatch },
} = promo;

interface Props {
    matchIdFullScreen: string | null;
    activeSidebarView: SidebarView;
    changeActiveTabHandler: (sidebarView: SidebarView) => void;
    tabsData: Partial<{ [key in SidebarView]: string }>;
    extraTab?: JSX.Element;
    areSportsAvailable: boolean;
}

const Sidebar: React.FC<Props> = ({
    tabsData,
    activeSidebarView,
    changeActiveTabHandler,
    matchIdFullScreen,
    extraTab,
    areSportsAvailable,
}) => {
    return (
        <div styleName="container" className="__app-Sidebar-container">
            {keys(tabsData).length > 0 && (
                <Tabs
                    activeTab={activeSidebarView}
                    data={tabsData as { [key: string]: string }}
                    changeActiveTab={changeActiveTabHandler}
                    extraTab={extraTab}
                />
            )}

            <div styleName="content" className="__app-Sidebar-content">
                {activeSidebarView === SidebarView.betslip && (
                    <AsyncBetslipList />
                )}

                {activeSidebarView === SidebarView.bets && (
                    <AsyncBetsHistoryContainer />
                )}

                {activeSidebarView === SidebarView.promo && areSportsAvailable && (
                    <Scrollbars>
                        <TopMatch
                            zoneLocation={
                                BannerTypes.BannerZoneLocation.TOP_SPORT_EVENTS
                            }
                        />

                        <BannersCarousel
                            zoneLocation={
                                BannerTypes.BannerZoneLocation.RIGHT_SLIDER
                            }
                        />

                        <Banners zoneLocation={BannerZoneLocation.RIGHT} />
                    </Scrollbars>
                )}

                {activeSidebarView === SidebarView.live &&
                    !!matchIdFullScreen && (
                        <AsyncSidebarMarketList matchId={matchIdFullScreen} />
                    )}
            </div>
        </div>
    );
};

export default Sidebar;
